export default "__VITE_ASSET__FHEd4JQp__"